import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const ResetPasswordPageContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ResetPasswordPageContainer" */
      './ResetPasswordPageContainer.dynamic'
    ),
  loading: LoadingPageLoadable,
});
